import React, {Component} from 'react';
import style from './style.less';
import Header from '../header';
import {Grid, Row, Col} from 'react-bootstrap';

export default class Layout extends Component {

	render() {
		return (
			<div id="app" className={style.layout}>
			
				<Grid style={{
					marginTop: 50
				}}>
					<Row>
						<Col md={12}>
							{this.props.children}
						</Col>
					</Row>
				</Grid>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/layout/index.js